var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeyond1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 80,
    viewBox: "0 0 95 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyond1);
export default __webpack_public_path__ + "static/media/beyond1.d934416e070f3b80b531bfc71d3d2bf2.svg";
export { ForwardRef as ReactComponent };